"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MenuNotification = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _NotificationsNone = _interopRequireDefault(require("@material-ui/icons/NotificationsNone"));

var _styles = require("@material-ui/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-bitwise */
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    iconContainer: {
      backgroundColor: theme.palette.primary.main,
      height: 54,
      width: 63
    },
    iconItem: {
      color: '#FFFFFF',
      height: '100%',
      width: '100%'
    },
    notificationOn: {
      borderRadius: '50%',
      backgroundColor: '#FFB400',
      height: 15,
      position: 'absolute',
      right: 14,
      top: 11,
      width: 16,
      zIndex: 10
    },
    notificationOff: {
      display: 'none'
    }
  };
});

var MenuNotification = function MenuNotification(_ref) {
  var notification = _ref.notification,
      onClick = _ref.onClick;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.iconContainer
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    className: classes.iconItem,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_NotificationsNone.default, {
    style: {
      height: 40,
      width: 40
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: notification ? classes.notificationOn : classes.notificationOff
  })));
};

exports.MenuNotification = MenuNotification;
MenuNotification.propTypes = {
  onClick: _propTypes.default.func.isRequired,
  notification: _propTypes.default.bool.isRequired
};
var _default = MenuNotification;
exports.default = _default;